import {
  Container,
  HeadingText,
  Text,
  GetStartedButton,
  ImageContainer,
  StyledImage,
  InnerContainer,
  RequestDemoButton,
  ButtonContainer
} from './StartCrypto.style';
import { RightIcon } from '../../../assets/svg';
import StartCryptoImage from '../../../assets/images/StartCryptoImage.webp';

export const StartCryptoSection = () => {
  return (
    <Container>
      <InnerContainer>
        <HeadingText>Start accepting crypto payments in minutes.</HeadingText>
        <Text>
          A Non-custodial, easy-to-integrate solution to accept and manage all
          crypto payments. Accept payments on 8+ blockchain networks in 50+
          currencies.
        </Text>
        <ButtonContainer>
          <GetStartedButton
            role="button"
            target="_blank"
            rel="noreferrer"
            href={process.env.REACT_APP_DASHBOARD_URL}
          >
            Get Started <RightIcon />
          </GetStartedButton>
          <RequestDemoButton
            role="button"
            target="_blank"
            rel="noreferrer"
            href="https://docs.google.com/forms/d/e/1FAIpQLSfzac7nMjDdQGgzymaT0p7sBZc2ztDG2LD7OLcI5tuDoZwrbA/viewform"
          >
            Request a Demo
          </RequestDemoButton>
        </ButtonContainer>
        <ImageContainer>
          <StyledImage src={StartCryptoImage} />
        </ImageContainer>
      </InnerContainer>
    </Container>
  );
};
